// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__10XpG","alertIcon":"ConfirmModal_alertIcon__3kwHt"};